export const GET_CHEMICAL_PRODUCT_INITIAL_DATA = 'GET_CHEMICAL_PRODUCT_INITIAL_DATA';
export const GET_CHEMICAL_PRODUCT_INITIAL_DATA_SUCCESS = `${GET_CHEMICAL_PRODUCT_INITIAL_DATA}/SUCCESS`;
export const GET_CHEMICAL_PRODUCT_INITIAL_DATA_FAILURE = `${GET_CHEMICAL_PRODUCT_INITIAL_DATA}/FAILURE`;

export const GET_CHEMICAL_PRODUCT = 'GET_CHEMICAL_PRODUCT';
export const GET_CHEMICAL_PRODUCT_SUCCESS = `${GET_CHEMICAL_PRODUCT}/SUCCESS`;
export const GET_CHEMICAL_PRODUCT_FAILURE = `${GET_CHEMICAL_PRODUCT}/FAILURE`;

export const GET_CHEMICAL_PRODUCT_SDS_FILES = 'GET_CHEMICAL_PRODUCT_SDS_FILES';
export const GET_CHEMICAL_PRODUCT_SDS_FILES_SUCCESS = `${GET_CHEMICAL_PRODUCT_SDS_FILES}/SUCCESS`;
export const GET_CHEMICAL_PRODUCT_SDS_FILES_FAILURE = `${GET_CHEMICAL_PRODUCT_SDS_FILES}/FAILURE`;

export const GET_CHEMICAL_PRODUCT_TITLE_DETAILS = 'GET_CHEMICAL_PRODUCT_TITLE_DETAILS';
export const GET_CHEMICAL_PRODUCT_TITLE_DETAILS_SUCCESS = `${GET_CHEMICAL_PRODUCT_TITLE_DETAILS}/SUCCESS`;
export const GET_CHEMICAL_PRODUCT_TITLE_DETAILS_FAILURE = `${GET_CHEMICAL_PRODUCT_TITLE_DETAILS}/FAILURE`;

export const GET_ALL_NOT_DELETED = 'GET_ALL_NOT_DELETED';
export const GET_ALL_NOT_DELETED_SUCCESS = `${GET_ALL_NOT_DELETED}/SUCCESS`;
export const GET_ALL_NOT_DELETED_FAILURE = `${GET_ALL_NOT_DELETED}/FAILURE`;

export const SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL =
  'SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL';
export const SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS = `${SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL}/SUCCESS`;
export const SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_FAILURE = `${SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL}/FAILURE`;

export const DELETE_CHEMICAL_PRODUCT = 'DELETE_CHEMICAL_PRODUCT';
export const DELETE_CHEMICAL_PRODUCT_SUCCESS = `${DELETE_CHEMICAL_PRODUCT}/SUCCESS`;
export const DELETE_CHEMICAL_PRODUCT_FAILURE = `${DELETE_CHEMICAL_PRODUCT}/FAILURE`;

export const GET_NEW_CHEMICAL_PRODUCT = 'GET_NEW_CHEMICAL_PRODUCT';
export const GET_NEW_CHEMICAL_PRODUCT_FROM_CURRENT = 'GET_NEW_CHEMICAL_PRODUCT_FROM_CURRENT';

export const STATE_CHANGE = 'STATE_CHANGE';
export const CMR_CLASS_CALCULATION = 'CMR_CLASS_CALCULATION';
export const HAZARDS_CALCULATION = 'HAZARDS_CALCULATION';
export const UPDATE_CHEM_PROD_TITLE = 'UPDATE_CHEM_PROD_TITLE';
export const CHEM_PROD_LIST_MUST_REFRESH = 'CHEM_PROD_LIST_MUST_REFRESH';

export default {
  GET_CHEMICAL_PRODUCT_INITIAL_DATA,
  GET_CHEMICAL_PRODUCT_INITIAL_DATA_SUCCESS,
  GET_CHEMICAL_PRODUCT_INITIAL_DATA_FAILURE,

  GET_CHEMICAL_PRODUCT,
  GET_CHEMICAL_PRODUCT_SUCCESS,
  GET_CHEMICAL_PRODUCT_FAILURE,

  GET_CHEMICAL_PRODUCT_SDS_FILES,
  GET_CHEMICAL_PRODUCT_SDS_FILES_SUCCESS,
  GET_CHEMICAL_PRODUCT_SDS_FILES_FAILURE,

  GET_CHEMICAL_PRODUCT_TITLE_DETAILS,
  GET_CHEMICAL_PRODUCT_TITLE_DETAILS_SUCCESS,
  GET_CHEMICAL_PRODUCT_TITLE_DETAILS_FAILURE,

  DELETE_CHEMICAL_PRODUCT,
  DELETE_CHEMICAL_PRODUCT_SUCCESS,
  DELETE_CHEMICAL_PRODUCT_FAILURE,

  SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL,
  SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS,
  SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_FAILURE,

  GET_NEW_CHEMICAL_PRODUCT,
  GET_NEW_CHEMICAL_PRODUCT_FROM_CURRENT,

  STATE_CHANGE,
  CMR_CLASS_CALCULATION,
  HAZARDS_CALCULATION,
  UPDATE_CHEM_PROD_TITLE
};
